import { render, staticRenderFns } from "./UserAddCustomLog.vue?vue&type=template&id=190fa224&"
import script from "./UserAddCustomLog.vue?vue&type=script&lang=js&"
export * from "./UserAddCustomLog.vue?vue&type=script&lang=js&"
import style0 from "./UserAddCustomLog.vue?vue&type=style&index=0&id=190fa224&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports